import { Button, Form, Input, message, Typography } from 'antd';
import ResizeWrapper from '@/components/ResizeWrapper';
import styles from './index.module.less';
import React, { useEffect } from 'react';
import { NavBar } from 'antd-mobile';
import { post } from '@/utils/request';
import { useNavigate } from 'react-router-dom';

const { Text, Link } = Typography;

export interface FormProps {
  username: string;
  password: string;
}

export default function() {

  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleStart = async (formValues: FormProps) => {
    post("/ums/web/auth/login/password",{
      credential: formValues.username,
      password: formValues.password,
    }).then((res)=>{
      if(res.code === 200){
        console.log(res);
        let accessToken = res.data.accessToken;
        let userInfo = res.data;
        localStorage.setItem('accessToken',accessToken);
        localStorage.setItem('userInfo',JSON.stringify(userInfo));
        //跳转到首页
        navigate("/");
      }else{
        message.error(res.msg)
      }
    })
  };

  return (
    <ResizeWrapper className={styles.container}>

      <NavBar
        className={styles.navBar}
        style={{ height: 65 }}
        children={<div className={styles.navBarTitle}>登录</div>}
        onBack={() => {
          history.back();
        }}
      />

      {/*<Header />*/}
      <div className={styles['form-wrapper']} style={{ alignItems: 'flex-start',marginTop: 80}}>
        <div className={styles.main} style={{width: '100%'}}>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleStart}
            style={{ width: '80%' }}
          >
            <Form.Item name="username">
              <Input size='large' placeholder="请输入用户名" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item name="password">
              <Input.Password size='large' placeholder="请输入密码" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item
            >
              <Button
                type="primary"
                htmlType="submit"
                size='middle'
                className={styles.startButton}
              >
                登录
              </Button>
            </Form.Item>

            <div style={{ textAlign: 'center' }}>
              没有账号？
              <Link href="/Login/reg">
                注册
              </Link>
            </div>

          </Form>
        </div>
      </div>
    </ResizeWrapper>
  );
}
